/**
 * @module converse-oauth
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */
import { LitElement } from 'lit';
import Keycloak from "keycloak-js";

import "./styles.scss";


const plugin = {
    optional_dependencies: ['converse-register'],

    async initialize () {
        const { _converse } = this;
        const { api, __ } = _converse;
        const { Collection, Model, CustomElement, html } = converse.env;

        api.settings.extend({
            'oauth_providers': {},
            'keycloak': {}
        });

        const tpl_provider = (o, provider) => html`
            <p class="oauth-provider">
                <a @click=${o.oauthLogin} class="oauth-login" data-id="${provider.id}">
                    <i class="fa ${provider.class}"></i>${provider.login_text}
                </a>
            </p>
        `;

        const tpl_oauth_providers = o => html`
            <fieldset class="oauth-providers">
                ${ o.providers.map(provider => tpl_provider(o, provider)) }
            </fieldset>
        `;

        const kc_config = api.settings.get('keycloak')

        const keycloak = new Keycloak({
            url: kc_config.url,
            realm: kc_config.realm,
            clientId: kc_config.client_id
        });

        await keycloak.init({ onLoad: "login-required" })

        api.listen.on("beforeAttemptNonPreboundSession", (_ctx, payload) => ({
            ...payload,
            credentials: { jid: keycloak.idTokenParsed.jid, password: keycloak.token }
        }));

        api.user.login(keycloak.idTokenParsed.jid, keycloak.token)

        api.listen.on("beforeLogout", (_ctx, _payload) => {
            keycloak.logout()
        });

        const LoginForm = api.elements.registry['converse-login-form']

        class OAuthLoginForm extends LoginForm {
            render () {
                return html`
                <h2>Login with keycloak</h2>
                `
            }
        }

        api.elements.define('converse-login-form', OAuthLoginForm)
    }
}

let converse = window.converse;

if (typeof converse === "undefined") {
    window.addEventListener(
        'converse-loaded',
        (ev) => {
            converse = ev.detail?.converse || ev.converse;
            converse.plugins.add("converse-keycloak", plugin)
        }
    );
} else {
    converse.plugins.add("converse-keycloak", plugin);
}
